module.exports = __webpack_public_path__ + "img/2019.07.0c92441a.jpg";